import { render, staticRenderFns } from "./ArticleQuote.vue?vue&type=template&id=20e6e516&"
import script from "./ArticleQuote.vue?vue&type=script&lang=js&"
export * from "./ArticleQuote.vue?vue&type=script&lang=js&"
import style0 from "./ArticleQuote.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports